import projectsBgImg from 'images/projects/projectsBg.webp';
import cableDesignImg from 'images/projects/cableDesign.webp';
import cableDesign1Img from 'images/projects/cableDesign1.webp';
import cableDesign2Img from 'images/projects/cableDesign2.webp';
import cableDesign3Img from 'images/projects/cableDesign3.webp';
import wirelessCom1Img from 'images/projects/wirelessCom1.webp';
import wirelessCom2Img from 'images/projects/wirelessCom2.webp';
import wirelessCom3Img from 'images/projects/wirelessCom3.webp';
import wirelessCommunicationBgImg from 'images/projects/wirelessCommunicationBg.webp';
import projectsEnergy1Img from 'images/projects/projectsEnergy1.webp';
import projectsEnergy2Img from 'images/projects/projectsEnergy2.webp';
import projectsEnergy3Img from 'images/projects/projectsEnergy3.webp';
import projectEngineering1Img from 'images/projects/projectEngineering1.webp';
import projectEngineering2Img from 'images/projects/projectEngineering2.webp';
import projectEngineering3Img from 'images/projects/projectEngineering3.webp';
import projectTechnologyDeployment1Img from 'images/projects/projectTechnologyDeployment1.webp';
import projectTechnologyDeployment2Img from 'images/projects/projectTechnologyDeployment2.webp';
import projectTechnologyDeployment3Img from 'images/projects/projectTechnologyDeployment3.webp';
import constructionImg from 'images/projects/construction.webp';
import energyImg from 'images/projects/energy.webp';
import engineeringImg from 'images/projects/engineering.webp';
import technologyImg from 'images/projects/technology.webp';
import wirelessImg from 'images/projects/wireless.webp';
import projectEnergyBgImg from 'images/projects/projectEnergyBg.webp';
import projectEngeneeringBgImg from 'images/projects/projectEngeneeringBg.webp';
import technologyDeploymentBgImg from 'images/projects/technologyDeploymentBg.webp';

export const projectsBg = (projectsBgImg as any).src || projectsBgImg;
export const cableDesign = (cableDesignImg as any).src || cableDesignImg;
export const cableDesign1 = (cableDesign1Img as any).src || cableDesign1Img;
export const cableDesign2 = (cableDesign2Img as any).src || cableDesign2Img;
export const cableDesign3 = (cableDesign3Img as any).src || cableDesign3Img;
export const wirelessCom1 = (wirelessCom1Img as any).src || wirelessCom1Img;
export const wirelessCom2 = (wirelessCom2Img as any).src || wirelessCom2Img;
export const wirelessCom3 = (wirelessCom3Img as any).src || wirelessCom3Img;
export const wirelessCommunicationBg = (wirelessCommunicationBgImg as any).src || wirelessCommunicationBgImg;
export const projectsEnergy1 = (projectsEnergy1Img as any).src || projectsEnergy1Img;
export const projectsEnergy2 = (projectsEnergy2Img as any).src || projectsEnergy2Img;
export const projectsEnergy3 = (projectsEnergy3Img as any).src || projectsEnergy3Img;
export const projectEngineering1 = (projectEngineering1Img as any).src || projectEngineering1Img;
export const projectEngineering2 = (projectEngineering2Img as any).src || projectEngineering2Img;
export const projectEngineering3 = (projectEngineering3Img as any).src || projectEngineering3Img;
export const projectTechnologyDeployment1 = (projectTechnologyDeployment1Img as any).src || projectTechnologyDeployment1Img;
export const projectTechnologyDeployment2 = (projectTechnologyDeployment2Img as any).src || projectTechnologyDeployment2Img;
export const projectTechnologyDeployment3 = (projectTechnologyDeployment3Img as any).src || projectTechnologyDeployment3Img;
export const construction = (constructionImg as any).src || constructionImg;
export const energy = (energyImg as any).src || energyImg;
export const engineering = (engineeringImg as any).src || engineeringImg;
export const technology = (technologyImg as any).src || technologyImg;
export const wireless = (wirelessImg as any).src || wirelessImg;
export const projectEnergyBg = (projectEnergyBgImg as any).src || projectEnergyBgImg;
export const projectEngeneeringBg = (projectEngeneeringBgImg as any).src || projectEngeneeringBgImg;
export const technologyDeploymentBg = (technologyDeploymentBgImg as any).src || technologyDeploymentBgImg;